import $ from 'jquery';

class Node {
  constructor(variant) {
    this.variant = variant;
    this.optionsCount = this.variant.options.length;
    this.neighbors = [];

    for (let i = 0; i < this.optionsCount; i++) {
      this.neighbors.push([]);
    }
  }

  addNeighbor(variant) {
    for (let i = 0; i < this.optionsCount; i++) {
      if (this.variant.options[i] !== variant.options[i]) {
        this.neighbors[i].push(variant);
        break;
      }
    }
  }

  getValidOptions() {
    const options = [];

    for (let i = 0; i < this.optionsCount; i++) {
      options.push([]);
    }

    for (let i = 0; i < this.optionsCount; i++) {
      this.neighbors[i].forEach((item, key) => {
        options[i].push(this.neighbors[i][key].options[i]);
      });

      options[i] = $.uniqueSort(options[i]);
    }

    return options;
  }
}

export default class ProductOptions {
  constructor(product) {
    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = product.variants;
    this.nodeMap = {};

    this._generateNodeMap(product);
  }

  _generateNodeMap() {
    this.variants.forEach(variant => {
      this.nodeMap[variant.id] = new Node(variant);

      this.variants.forEach(variant2 => {
        this.nodeMap[variant.id].addNeighbor(variant2);
      });
    });
  }

  getVariantFromOptions(options) {
    for (let i = 0; i < this.variants.length; i++) {
      const variant = this.variants[i];
      let found = true;

      for (let j = 0; j < variant.options.length; j++) {
        if (options[j] !== variant.options[j]) {
          found = false;
        }
      }

      if (found) {
        return variant;
      }
    }

    return false;
  }

  getClosestVariantFromOptions(options) {
    let closestVariant = null;
    let matchingValues = 0;

    this.variants.forEach(variant => {
      let tempMatchingValues = 0;

      for (let i = 0; i < variant.options.length; i++) {
        if (options[i] === variant.options[i]) {
          tempMatchingValues++;
        } else {
          break;
        }
      }

      if (tempMatchingValues >= matchingValues) {
        closestVariant = variant;
        matchingValues = tempMatchingValues;
      }
    });

    return closestVariant ? closestVariant : false;
  }

  getVariantOrClosestFromOptions(options) {
    return this.getVariantFromOptions(options)
      || this.getClosestVariantFromOptions(options);
  }

  getAvailableOptionsFromVariant(variant) {
    return this.nodeMap[variant.id].getValidOptions();
  }
}
